export default __webpack_public_path__ + "static/mni-3dbc8555b52589a92934f313d178ae6f.png";